import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { RecordingsStore, RecordingsStoreType } from '@appState/marketing/recordings/recordings.store';
import { CuiCardModule, ParseHtmlPipe } from 'cui-components';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'hui-recording-preview',
  imports: [CommonModule, CuiCardModule, ParseHtmlPipe, MatProgressSpinnerModule],
  templateUrl: './recording-preview.component.html',
  styleUrls: ['./recording-preview.component.scss'],
})
export class RecordingPreviewComponent {
  private recordingsStore: RecordingsStoreType = inject(RecordingsStore);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private sanitizer: DomSanitizer = inject(DomSanitizer);

  selectedRecording = this.recordingsStore.selectedRecording;
  isLoading: Signal<boolean> = computed(() => this.recordingsStore.isSelectedRecordingLoading());

  environment = environment;

  constructor() {
    const recordingId = this.activatedRoute.snapshot.params['recordingId'];
    if (recordingId && (!this.selectedRecording() || this.selectedRecording()?.id !== recordingId)) {
      this.recordingsStore.getOne(recordingId);
    }
  }

  getVideoUrl(externalVideoId: string): string {
    return `https://play.gumlet.io/embed/${externalVideoId}?background=false&autoplay=false&loop=false&disableControls=false`;
  }

  getSafeVideoUrl(externalVideoId: string): SafeResourceUrl {
    const url = this.getVideoUrl(externalVideoId);
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
